function sampleTagSelectDirective() {
	return {
		scope : {
			tag : '=',
			tagInitValues : "=?",
			availableTagsModel : '=?availableTags',
			onTagChange : '&?'
		},
		restrict : 'E',
		templateUrl : function(elem, attr) {
			return 'views/directives/sampleTagSelectDirective.html';
		},
		controller : [ '$scope', '$window', 'alertService', function($scope, $window, alertService) {
			$scope.availableTags = [];

			if ($scope.availableTagsModel)
				$scope.availableTags = $scope.availableTagsModel;

			if (!angular.isUndefined($scope.tagInitValues)) {
				$scope.tag.selected = [];
				$scope.tagInitValues.forEach(function(t) {
					$scope.tag.selected.push(t);
					if (!$scope.availableTags.some(function(item) {
						return t === item
					})) {
						$scope.availableTags.push(t);
					}
				});
			}

			$scope.onRemove = function(item) {
				if ($scope.onTagChange)
					$scope.onTagChange();
			}

			$scope.onSelect = function(item) {
				if ($scope.onTagChange)
					$scope.onTagChange();
				if (!$scope.availableTags.some(function(t) {
					return t === item
				})) {
					$scope.availableTags.push(item);
				}
			}
		} ]
	};
};

module.directive('sampleTagSelect', [ sampleTagSelectDirective ]);
